<image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 3"
    [onlyScaleDown]="true" outputType="both" [resizeToWidth]="309" [cropperMinWidth]="109" format="png"
    (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
    (loadImageFailed)="loadImageFailed()"></image-cropper>
<div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center">
    <button mat-flat-button [color]="'primary'" (click)="cropped()">{{'Upload'|translate}}</button>
    <button mat-flat-button [color]="'warn'" mat-dialog-close>{{'Cancel'|translate}}</button>
</div>